import get from 'lodash.get';
import { constants } from '@yola/subscription-manager-js';

const {
  hostingPackageFeatureNames: { PREMIUM_COMPOSITE_GROUP },
} = constants;

const premiumCompositeGroupLimit = ({ targetPackage }) => ({
  available: get(targetPackage, ['features', PREMIUM_COMPOSITE_GROUP], false),
});

export default premiumCompositeGroupLimit;
